<template>
    <router-link :to="getRouteFromID" class="hyperLink" v-if="hasInternalLink" :style="{'color': blackLinkText ? '#000' : '#ffaf37'}">
        <div>
            <img src="@/assets/img/ui/btn-arrow.svg" v-if="!blackLinkText">
            <img src="@/assets/img/ui/btn-arrow-black.svg" v-else>
        </div>
        {{ link.linkText }}
    </router-link>
    <a :href="link.linkUrl" class="hyperLink" v-else-if="hasExternalLink" target="_blank" @click="trackExternalLink(link.linkUrl)" :style="{'color': blackLinkText ? '#000' : '#ffaf37'}">
        <div>
            <img src="@/assets/img/ui/btn-arrow.svg" v-if="!blackLinkText">
            <img src="@/assets/img/ui/btn-arrow-black.svg" v-else>
        </div>
        {{ link.linkText }}
    </a>
</template>
<script>
export default {
    name: "Link",
    props: ["link", "pageData"],
    methods: {
        trackExternalLink(url) {
            _paq.push(["trackEvent", "external-link", window.app.vm.$route.path, url]);
        }
    },
    computed: {
        hasInternalLink() {
            return this.link.internalLink !== null
        },
        hasExternalLink() {
            return this.link.linkUrl !== ''
        },  
        getRouteFromID() {
            if(this.link.internalLink === null)
                return

            return app.manifest.getRouteFromID(this.link.internalLink);
        },
        blackLinkText() {
            return this.pageData.color === '#ffaf37';
        }
    }
};
</script>